import { createAsyncThunk } from '@reduxjs/toolkit'
import { NftItem } from '../types'
import { AppState } from 'state'

const fetchNext = createAsyncThunk<
  {
    items: NftItem[]
    hasMore: boolean
  },
  void,
  { state: AppState }
>('nft/getNext', async (_, thunkApi) => {
  const { limit, offset, orderBy, orderByAs, search, items } = thunkApi.getState().nft

  if (items.length >= 100) {
    return { items, hasMore: false }
  }

  const res = await fetch(
    `${process.env.REACT_APP_NFT_STATS_API_URL}/nftstats?orderBy=${orderBy}&orderByAs=${orderByAs}&offset=${offset}&limit=${limit}&search=${search}`
  )
  const newItems = await res.json()
  const combinedItems: NftItem[] = [...items, ...newItems]
  let hasMore = true

  if (newItems.error || newItems.length < limit) {
    hasMore = false
  }

  return { items: combinedItems, hasMore }
})

export default fetchNext
